import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import type { PageContext } from 'vike/types'
export function onBeforeRenderClient(pageContext: PageContext) {
  if (pageContext.pinia) {
    pageContext.pinia.use(piniaPluginPersistedstate)
  }
}
